import useAPI from '../../hooks/useAPI';
import { buildApiUrl } from '../config';

export const useDeleteEmploymentSchedule = () => {
  const { callAPI, ...state } = useAPI({ method: 'DELETE' });

  /**
   * Delete an employment schedule
   * @param scheduleId - The schedule ID
   * @returns Promise with boolean indicating success
   */
  const action = async (scheduleId: string): Promise<boolean> => {
    try {
      await callAPI(buildApiUrl(`employmentSchedule/${scheduleId}`), null, {
        deleteTarget: 'employmentSchedule',
      });
      return true;
    } catch {
      return false;
    }
  };

  return {
    action,
    ...state,
  };
};
